import { Model } from "@singularsystems/neo-core";
import { NeoGrid } from "@singularsystems/neo-react";
import { CatalogueEntry } from "../CatalogueEntry";
import DataCache from "../../../Services/DataCache";
import * as CatalogueRoles from "../../../Models/Security/CatalogueRoles"
import { IGenericApiClient } from "../../../ApiClients/Catalogues/GenericApiClient";
import { Catalogue } from "@singularsystems/neo-react-services";
import SARSNatureOfPerson from "../../../Models/Catalogue/General/SARSNatureOfPerson";

export default class SARSNatureOfPersonCatalogueEntry extends CatalogueEntry<SARSNatureOfPerson> {

    constructor() {
        super("SARS Nature Of Person", SARSNatureOfPerson);
    }

    public get editRole() {
        return CatalogueRoles.SARSIDTypes.Edit;
    }

    public getCacheEntry(cache: DataCache) {
        return cache.sarsNatureOfPerson;
    }

    public getSaveEndpoint(apiClient: IGenericApiClient) {
        return apiClient.saveSARSNatureOfPerson;
    }

    public renderRow(item: SARSNatureOfPerson, meta: Model.TransformMetaType<SARSNatureOfPerson>) {
        return (
            <NeoGrid.Row>
                <NeoGrid.Column bind={meta.code} />
                <NeoGrid.Column bind={meta.description} />
                <Catalogue.ButtonColumn />
            </NeoGrid.Row>
        )
    }
}